import { useAppSelector } from '@store/hooks';
import { selectAuthUser, selectPermissions } from '@store/reducers/authSlice';

const usePermissionGuard = () => {
  const permissions = useAppSelector(selectPermissions);
  const authUser = useAppSelector(selectAuthUser);

  const hasPermission = (permission: string): boolean => {
    if (authUser?.isSuperAdmin) {
      return true;
    }

    if (permissions.includes(permission)) {
      return true;
    }
    return false;
  };

  return { hasPermission };
};
export default usePermissionGuard;
